import { render, staticRenderFns } from "./InformDetail.vue?vue&type=template&id=73494770&scoped=true&"
import script from "./InformDetail.vue?vue&type=script&lang=js&"
export * from "./InformDetail.vue?vue&type=script&lang=js&"
import style0 from "./InformDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InformDetail.vue?vue&type=style&index=1&id=73494770&scoped=true&lang=scss&"
import style2 from "./InformDetail.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73494770",
  null
  
)

export default component.exports